const musicLinksES = {
    "view": {
        "table": {
            "title": "Tu lista de enlaces de música",
            "column": {
                "releaseName": "Nombre del Lanzamiento",
                "artists": "Artistas",
                "owner": "Propietario",
                "created": "Creado",
                "musicLink": "Enlace de Música",
                "action": "Acción"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "message": {
                "linkCopied": "¡Enlace copiado al portapapeles!"
            }
        },
        "modal": {
            "edit": {
                "header": "¿Editar {{musicLinkName}}?",
                "body": "¿Estás seguro de que deseas editar este enlace de música?"
            },
            "delete": {
                "header": "¿Eliminar {{musicLinkName}}?",
                "body": "¿Estás seguro de que deseas eliminar este enlace de música?"
            }
        },
        "message": {
            "success": "¡El enlace de música ha sido eliminado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "mlAllowanceSpent": "Has gastado tu asignación de enlaces de música. Para crear más enlaces de música, por favor actualiza tu cuenta o contacta a nuestro equipo de soporte.",
            "subscriptionFeatureUnavailable": "Tu plan de suscripción actual no admite esta función. Por favor <1>actualiza</1> tu plan de suscripción para disfrutar de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "moduleAccessRestricted": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "add": {
        "title": "Agregar Enlace de Música",
        "form": {
            "label": {
                "source": "Fuente",
                "subUser": "Sub-Usuario",
                "release": "Lanzamiento",
                "artwork": "Arte",
                "releaseName": "Nombre del Lanzamiento",
                "upcEan": "UPC/EAN",
                "artistName": "Nombre del Artista",
                "urlPart1": "Parte de URL 1",
                "urlPart2": "Parte de URL 2",
                "musicLinkUrl": "Tu URL de enlace de música es",
                "searchBy": "Buscar Por",
                "upcNumber": "Número UPC",
                "storeReleaseUrl": "URL de Lanzamiento en Tienda",
                "colorCustomisation": "Personalización de Color",
                "premadeColors": "Colores Prediseñados",
                "customColors": "Colores Personalizados",
                "buttonStyle": "Estilo del Botón",
                "headerBackground": "Fondo del Encabezado",
                "singleColor": "Color Único",
                "gradient": "Degradado",
                "playerControlsColor": "Color de Controles del Reproductor",
                "titleColor": "Color del Título",
                "descriptionColor": "Color de la Descripción",
                "buttonColor": "Color del Botón",
                "buttonHoverColor": "Color del Botón al Pasar el Ratón",
                "buttonTextColor": "Color del Texto del Botón"
            },
            "placeholder": {
                "subUser": "Seleccionar Sub-usuario...",
                "release": "Seleccionar Lanzamiento",
                "releaseUpc": "Introducir Número UPC/EAN del Lanzamiento, ej. 5055964352523",
                "releaseStoreUrl": "Introducir URL de Lanzamiento en Tienda, ej. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "urlPart1": "Seleccionar Parte de URL 1"
            },
            "help_text": {
                "subUser": "Nota: Solo usa este menú desplegable si deseas agregar un enlace de música para alguno de tus Sub-usuarios, de lo contrario, déjalo sin seleccionar.",
                "release": "Nota: Solo puedes seleccionar lanzamientos que estén <strong>Distribuidos.</strong>",
                "releaseUpc": "Nota: Solo usa este menú desplegable si deseas agregar un Lanzamiento que ya esté en Spotify o Deezer.",
                "releaseStoreUrl": "Nota: Solo usa este menú desplegable si deseas agregar un Lanzamiento que ya esté en Spotify o Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Lanzamiento de Enlace de Música Existente",
                    "externalRelease": "Lanzamiento Externo"
                },
                "buttonStyle": {
                    "outlined": "Contorneado",
                    "filled": "Relleno"
                }
            },
            "button": {
                "reset": "Restablecer",
                "createNew": "¿Crear Nuevo?",
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "¡El formulario no puede ser enviado! Por favor, completa todos los campos y verifica los errores.",
                "storeUrlRequired": "Se requiere la URL de {{store}}",
                "storeUrlValid": "Por favor, añade una URL válida de {{store}}."
            }
        },
        "message": {
            "success": "¡El enlace de música ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "fetchingReleaseDetails": "Obteniendo detalles del lanzamiento..."
        }
    },
    "update": {
        "title": "Editar Enlace de Música",
        "form": {
            "label": {
                "source": "Fuente",
                "release": "Lanzamiento",
                "artwork": "Arte",
                "releaseName": "Nombre del Lanzamiento",
                "upcEan": "UPC/EAN",
                "artistName": "Nombre del Artista",
                "urlPart1": "Parte de URL 1",
                "urlPart2": "Parte de URL 2",
                "musicLinkUrl": "Tu URL de enlace de música es",
                "searchBy": "Buscar Por",
                "upcNumber": "Número UPC",
                "storeReleaseUrl": "URL de Lanzamiento en Tienda",
                "colorCustomisation": "Personalización de Color",
                "premadeColors": "Colores Prediseñados",
                "customColors": "Colores Personalizados",
                "buttonStyle": "Estilo del Botón",
                "headerBackground": "Fondo del Encabezado",
                "singleColor": "Color Único",
                "gradient": "Degradado",
                "playerControlsColor": "Color de Controles del Reproductor",
                "titleColor": "Color del Título",
                "descriptionColor": "Color de la Descripción",
                "buttonColor": "Color del Botón",
                "buttonHoverColor": "Color del Botón al Pasar el Ratón",
                "buttonTextColor": "Color del Texto del Botón"
            },
            "placeholder": {
                "release": "Seleccionar Lanzamiento",
                "releaseUpc": "Introducir Número UPC/EAN del Lanzamiento, ej. 5055964352523",
                "releaseStoreUrl": "Introducir URL de Lanzamiento en Tienda, ej. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "urlPart1": "Seleccionar Parte de URL 1"
            },
            "help_text": {
                "release": "Nota: Solo puedes seleccionar lanzamientos que estén <strong>Distribuidos.</strong>",
                "releaseUpc": "Nota: Solo usa este menú desplegable si deseas agregar un Lanzamiento que ya esté en Spotify o Deezer.",
                "releaseStoreUrl": "Nota: Solo usa este menú desplegable si deseas agregar un Lanzamiento que ya esté en Spotify o Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Lanzamiento de Enlace de Música Existente",
                    "externalRelease": "Lanzamiento Externo"
                },
                "buttonStyle": {
                    "outlined": "Contorneado",
                    "filled": "Relleno"
                }
            },
            "button": {
                "reset": "Restablecer",
                "createNew": "¿Crear Nuevo?",
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "¡El formulario no puede ser enviado! Por favor, completa todos los campos y verifica los errores.",
                "storeUrlRequired": "Se requiere la URL de {{store}}",
                "storeUrlValid": "Por favor, añade una URL válida de {{store}}."
            }
        },
        "message": {
            "success": "¡El enlace de música ha sido actualizado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "fetchingReleaseDetails": "Obteniendo detalles del lanzamiento..."
        }
    },
    "storeLinksRow": {
        "title": "Enlaces de Tienda",
        "label": {
            "store": "Tienda",
            "link": "Enlace"
        },
        "button": {
            "remove": "Eliminar"
        },
        "model": {
            "addStore": {
                "header": "Agregar Tienda",
                "body": "Por favor, elige la tienda deseada de la lista a continuación:",
                "option": {
                    "mainStores": "Tiendas Principales",
                    "otherStores": "Otras Tiendas"
                },
                "button": {
                    "add": "Agregar Tienda",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Archivos de Vista Previa",
        "label": {
            "preview": "Vista Previa",
            "artistName": "Nombre del Artista",
            "trackName": "Nombre de la Pista"
        },
        "audioNotSupported": "Tu navegador no soporta el elemento de audio."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Elegir Servicio de Música",
            "track": "Pista",
            "artist": "Artista",
            "time": "Tiempo",
            "others": "Otros"
        },
        "button": {
            "play": "Reproducir"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Obteniendo estadísticas para el enlace de música"
        },
        "topServices": {
            "title": "Servicios Principales",
            "subtitle": "CLICK THROUGH POR SERVICIO",
            "table": {
                "column": {
                    "store": "Tienda",
                    "noOfVisits": "Total de Visitas",
                    "noOfVisitsPct": "Total de Visitas %"
                },
                "label": {
                    "otherStores": "Otras Tiendas"
                }
            }
        },
        "topTracks": {
            "title": "Pistas Principales",
            "subtitle": "CLICK THROUGH POR PISTA",
            "table": {
                "column": {
                    "trackName": "Nombre de la Pista",
                    "artistName": "Nombre del Artista",
                    "noOfPlays": "Número de Reproducciones",
                    "noOfPlaysPct": "Número de Reproducciones %"
                }
            }
        },
        "topTerritories": {
            "title": "Territorios Principales",
            "subtitle": "CLICK THROUGH POR TERRITORIO",
            "table": {
                "column": {
                    "territory": "Territorio",
                    "noOfViews": "Número de Vistas",
                    "noOfViewsPct": "Número de Vistas %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Tipos de Dispositivos Principales",
            "subtitle": "CLICK THROUGH POR TIPO DE DISPOSITIVO"
        },
        "topOperatingSystems": {
            "title": "Sistemas Operativos Principales",
            "subtitle": "CLICK THROUGH POR SO",
            "chart": {
                "label": {
                    "noOfViews": "Número de Vistas : ",
                    "operatingSystems": "Sistema Operativo"
                }
            }
        },
        "topBrowsers": {
            "title": "Navegadores Principales",
            "subtitle": "CLICK THROUGH POR NAVEGADOR",
            "table": {
                "column": {
                    "browser": "Navegador",
                    "noOfViewsPct": "Número de Vistas (%)"
                }
            }
        }
    }
};

export default musicLinksES;